import { CircularLoading, COOKIE_NAME } from '@myhrbox/myhrbox-frontend-core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cookies from 'js-cookie';
import { userLogout, $user } from 'store/user/model';
import client from 'config/apolloConfig';
import { Typography } from '@mui/material';
import Card from 'components/Card';
import useIsExaminationActive from 'hooks/useIsExaminationActive';
import AssesmentAccessCard from 'components/AssesmentAccessCard';
import RegisterForm from './RegisterForm';

const Register = () => {
  const { t } = useTranslation();
  const { isExaminationActive, loading, examinationId } = useIsExaminationActive();
  const [showAssesmentAccessCard, setShowAssesmentAccessCard] = useState(false);

  const logout = () => {
    localStorage.clear();

    cookies.remove(COOKIE_NAME.ACCESS_TOKEN);
    cookies.remove(COOKIE_NAME.REFRESH_TOKEN);

    userLogout();
    $user.watch((state) => {
      if (state === null) {
        client.resetStore();
      }
    });
  };

  useEffect(() => {
    if (examinationId) {
      logout();
    }
  }, []);

  if (loading || isExaminationActive === undefined) return <CircularLoading />;

  if (!isExaminationActive || showAssesmentAccessCard) return <AssesmentAccessCard />;

  return (
    <Card>
      <Typography variant='h28' sx={{ mb: 4 }}>
        {t('register.title')}
      </Typography>
      <RegisterForm
        examinationId={examinationId!}
        setShowAssesmentAccessCard={setShowAssesmentAccessCard}
      />
    </Card>
  );
};

export default Register;
